/*LIBRARY*/
import React, { useState } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";

/*REDUX*/
import { set_value_properties } from "../../App/actions/propertiesActions";
import { status_action } from "../../App/actions/mapActions";

/*PICTURE*/

/*FUNCTION*/
import { generate_paint } from "../../Functions/map_style/generate_paint";
import { extract_value_array } from "../../Functions/map_style/extract_value_array";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const RANGE_TEXT = ({
  auth,
  properties,
  set_value_properties,
  status_action,
}) => {
  //local state
  const [anchor, set_anchor] = useState(null);
  const [modal_add_item, set_modal_add_item] = useState(false);
  const [item, set_item] = useState("");
  const [color, set_color] = useState("#000000");
  const [index_edit, set_index_edit] = useState(0);
  const [color_edit, set_color_edit] = useState("#000000");
  const [modal_color_edit, set_modal_color_edit] = useState(false);

  const on_change = (e) => {
    const { name, value } = e.target;
    if (name === "item") set_item(value);
    else if (name === "color") set_color(value);
    else if (name === "color_edit") set_color_edit(value);
  };

  const toggle_color_edit = (event) => {
    set_modal_color_edit(!modal_color_edit);
    if (event) {
      set_anchor(event.currentTarget);
      const new_index_edit = event.target.id;
      const new_color_edit = event.target.dataset.color;
      if (new_color_edit) {
        set_index_edit(new_index_edit);
        set_color_edit(new_color_edit);
      }
    }
  };

  const on_color_edit = () => {
    set_modal_color_edit(false);
    const { paint_object_edited, style_parameter } = properties;
    const { color_logic, style_type } = style_parameter;

    if (color_logic === "by_text") {
      let color_key;
      if (style_type === "circle") {
        color_key = "circle-color";
      } else if (style_type === "line") {
        color_key = "line-color";
      } else if (style_type === "fill") {
        color_key = "fill-color";
      }

      const array = [...(paint_object_edited?.[color_key] || [])];
      if (
        array.length >= 2 &&
        array[0] === "match" &&
        Array.isArray(array[1])
      ) {
        array[Number(index_edit) + 1] = color_edit;
        const new_paint_object_edited = {
          ...paint_object_edited,
          [color_key]: array,
        };

        set_value_properties({
          key: "paint_object_edited",
          value: new_paint_object_edited,
        });
        set_value_properties({
          key: "style_parameter",
          value: {
            ...style_parameter,
            paint_object_edited: new_paint_object_edited,
          },
        });
        status_action();
      }
    }
  };

  const toggle_add_item = (e) => {
    set_modal_add_item(!modal_add_item);
    if (e) {
      set_anchor(e.currentTarget);
    }
  };

  const on_add_item = () => {
    set_modal_add_item(false);
    const { paint_object_edited, style_parameter } = properties;
    const { color_logic, style_type } = style_parameter;

    if (color_logic === "by_text") {
      let color_key;
      if (style_type === "circle") {
        color_key = "circle-color";
      } else if (style_type === "line") {
        color_key = "line-color";
      } else if (style_type === "fill") {
        color_key = "fill-color";
      }

      const array = [...(paint_object_edited?.[color_key] || [])];
      if (
        array.length >= 2 &&
        array[0] === "match" &&
        Array.isArray(array[1])
      ) {
        const item_index = array.indexOf(item);
        if (item_index > -1 && item_index < array.length - 1) return;

        const default_color = array[array.length - 1];
        array.pop();
        array.push(item, color);
        array.push(default_color);

        const new_paint_object_edited = {
          ...paint_object_edited,
          [color_key]: array,
        };

        set_value_properties({
          key: "paint_object_edited",
          value: new_paint_object_edited,
        });
        set_value_properties({
          key: "style_parameter",
          value: {
            ...style_parameter,
            paint_object_edited: new_paint_object_edited,
          },
        });
        status_action();
      }
    }
  };

  const on_move_up = (target_item) => {
    const { paint_object_edited, style_parameter } = properties;
    const { color_logic, style_type } = style_parameter;

    if (color_logic === "by_text") {
      let color_key;
      if (style_type === "circle") {
        color_key = "circle-color";
      } else if (style_type === "line") {
        color_key = "line-color";
      } else if (style_type === "fill") {
        color_key = "fill-color";
      }

      const array = [...(paint_object_edited?.[color_key] || [])];
      const index = array.indexOf(target_item);

      if (index > 2 && index % 2 === 0) {
        const temp = array[index - 2];
        array[index - 2] = array[index];
        array[index] = temp;

        const new_paint_object_edited = {
          ...paint_object_edited,
          [color_key]: array,
        };
        const value_array = extract_value_array(
          new_paint_object_edited,
          style_type,
        );
        const style_parameter_new = {
          ...style_parameter,
          paint_object_edited: new_paint_object_edited,
          value_array,
        };
        const paint_object_new = generate_paint(style_parameter_new);

        set_value_properties({
          key: "paint_object_edited",
          value: paint_object_new,
        });
        set_value_properties({
          key: "style_parameter",
          value: style_parameter_new,
        });
        status_action();
      }
    }
  };

  const on_move_down = (target_item) => {
    const { paint_object_edited, style_parameter } = properties;
    const { color_logic, style_type } = style_parameter;

    if (color_logic === "by_text") {
      let color_key;
      if (style_type === "circle") {
        color_key = "circle-color";
      } else if (style_type === "line") {
        color_key = "line-color";
      } else if (style_type === "fill") {
        color_key = "fill-color";
      }

      const array = [...(paint_object_edited?.[color_key] || [])];
      const index = array.indexOf(target_item);

      if (index >= 2 && index % 2 === 0 && index < array.length - 3) {
        const temp = array[index + 2];
        array[index + 2] = array[index];
        array[index] = temp;

        const new_paint_object_edited = {
          ...paint_object_edited,
          [color_key]: array,
        };
        const value_array = extract_value_array(
          new_paint_object_edited,
          style_type,
        );
        const style_parameter_new = {
          ...style_parameter,
          value_array,
          paint_object_edited: new_paint_object_edited,
        };
        const paint_object_new = generate_paint(style_parameter_new);

        set_value_properties({
          key: "paint_object_edited",
          value: paint_object_new,
        });
        set_value_properties({
          key: "style_parameter",
          value: style_parameter_new,
        });
        status_action();
      }
    }
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //global props
  const { style_parameter, paint_object_edited } = properties;

  //content
  const { style_type } = style_parameter;
  let color_key;
  if (style_type === "circle") {
    color_key = "circle-color";
  } else if (style_type === "line") {
    color_key = "line-color";
  } else if (style_type === "fill") {
    color_key = "fill-color";
  }

  const array = paint_object_edited?.[color_key] || [];

  const content = (
    <>
      <main style={{ maxHeight: "250px", overflowY: "scroll" }}>
        <table className="table full_width">
          <tbody>
            {array.map((array_item, idx) => {
              // Skip the first two elements (["get", field_key])
              if (idx < 2) return null;
              const is_first = idx === 2;
              const is_last = idx >= array.length - 4;
              if (idx % 2 === 0 && idx < array.length - 1) {
                return (
                  <tr key={idx}>
                    <td
                      style={{ width: "25px", verticalAlign: "middle" }}
                      className="text_center"
                    >
                      <div>
                        {!is_first && (
                          <button
                            className={`button_icon background_black ${
                              !is_last ? "margin_bottom" : ""
                            }`}
                            onClick={() => on_move_up(array_item)}
                          >
                            ↑
                          </button>
                        )}
                        {!is_last && (
                          <button
                            className="button_icon background_black"
                            onClick={() => on_move_down(array_item)}
                          >
                            ↓
                          </button>
                        )}
                      </div>
                    </td>
                    <td>{array_item}</td>
                    <td style={{ width: "20px", verticalAlign: "middle" }}>
                      <div
                        className="cursor_pointer"
                        id={idx}
                        data-color={array[idx + 1]}
                        onClick={toggle_color_edit}
                        style={{
                          backgroundColor: array[idx + 1],
                          width: "20px",
                          height: "20px",
                          border: "1px solid black",
                        }}
                      />
                    </td>
                  </tr>
                );
              } else {
                return null;
              }
            })}
          </tbody>
        </table>
      </main>
      <button
        className="button margin_top background_black"
        onClick={toggle_add_item}
      >
        {dict?.["Add"]?.[language]}
      </button>
    </>
  );

  const modal_add_item_content = (
    <FLOAT_MENU
      id="basic-menu"
      anchorEl={anchor}
      open={modal_add_item}
      onClose={toggle_add_item}
    >
      <div
        style={{
          padding: "0px 10px 0px 10px",
        }}
      >
        <p className="text_small">Nama</p>
        <input
          placeholder="Ketik nama"
          type="text"
          value={item}
          name="item"
          onChange={on_change}
        />
        <br />
        <p className="text_small">Warna</p>
        <input type="color" value={color} name="color" onChange={on_change} />
        <br />
        <p className="text_small">Warna (manual)</p>
        <input type="text" value={color} name="color" onChange={on_change} />
        <br />
        <button
          className="button margin_top background_black"
          onClick={on_add_item}
        >
          {dict?.["Add"]?.[language]}
        </button>
      </div>
    </FLOAT_MENU>
  );

  const modal_color_edit_content = (
    <FLOAT_MENU
      id="basic-menu"
      anchorEl={anchor}
      open={modal_color_edit}
      onClose={toggle_color_edit}
    >
      <div
        style={{
          padding: "0px 10px 0px 10px",
        }}
      >
        <p className="text_small">Warna</p>
        <input
          type="color"
          value={color_edit}
          name="color_edit"
          onChange={on_change}
        />
        <br />
        <p className="text_small">Warna (manual)</p>
        <input
          type="text"
          value={color_edit}
          name="color_edit"
          onChange={on_change}
        />
        <br />
        <button
          className="button margin_top background_black"
          onClick={on_color_edit}
        >
          Simpan perubahan
        </button>
      </div>
    </FLOAT_MENU>
  );

  return (
    <main>
      {content}
      {modal_add_item_content}
      {modal_color_edit_content}
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  set_value_properties,
  status_action,
})(RANGE_TEXT);
